module.exports = __webpack_public_path__ + "static/media/10.b233f18b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/10.jpg
// module id = 580
// module chunks = 0